var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _vm._l(_vm.customFields, function(field) {
        return [
          field.input_type === "checkbox"
            ? _c("input-field", {
                key: field.id,
                ref: "formInputField",
                refInFor: true,
                attrs: {
                  value: _vm.getValueInObject(field.uuid),
                  label: " ",
                  inputType: field.input_type,
                  size: field.size,
                  required: field.required,
                  "required-filled": _vm.requiredFilled,
                  checkboxOptions: [field],
                  fieldDisabled: field.disable,
                  formDisabled: _vm.disabled,
                  "object-data": _vm.objectData
                },
                on: {
                  updateCheckboxValue: function($event) {
                    return _vm.updateValue(field.uuid, $event)
                  }
                }
              })
            : _c("input-field", {
                key: field.id,
                ref: "formInputField",
                refInFor: true,
                attrs: {
                  value: _vm.getValueInObject(field.uuid, field.input_type),
                  label: field.label,
                  inputType: field.input_type,
                  size: field.size,
                  required: field.required,
                  "required-filled": _vm.requiredFilled,
                  selectOptions: field.list_name,
                  clearable: true,
                  fieldDisabled: field.disable,
                  formDisabled: _vm.disabled
                },
                on: {
                  input: function($event) {
                    return _vm.updateValue(field.uuid, $event)
                  }
                }
              })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ffca346", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffca346","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue
// module id = null
// module chunks = 